// extracted by mini-css-extract-plugin
export var button = "cookies-module--button--7be5d";
export var container = "cookies-module--container--edeb2";
export var content = "cookies-module--content--219c2";
export var emoji = "cookies-module--emoji--1dfc1";
export var text = "cookies-module--text--5431a";
export var title = "cookies-module--title--a14f4";